// extracted by mini-css-extract-plugin
export default {"Container":"Card_Container__mE8Xn","Content":"Card_Content__-0idH","Image":"Card_Image__nxd+K","Mega":"Card_Mega__bVFbL","Title":"Card_Title__YpeF4"};